import React from "react";
import { TextField, Box, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { SubmitHandler, useForm } from "react-hook-form";
import Link from "../components/Link";

export interface LoginFormProps {
  onSubmit: LoginFormSubmitHandler;
  isLoading: boolean;
}

interface LoginFormValues {
  email: string;
  password: string;
}

export type LoginFormSubmitHandler = SubmitHandler<LoginFormValues>;

const LoginForm = (props: LoginFormProps) => {
  const { register, handleSubmit } = useForm<LoginFormValues>();

  return (
    <Box component="form" onSubmit={handleSubmit(props.onSubmit)}>
      <TextField
        required
        fullWidth
        margin="normal"
        label="Email"
        type="email"
        variant="outlined"
        {...register("email")}
      />
      <TextField
        required
        fullWidth
        margin="normal"
        label="Password"
        type="password"
        variant="outlined"
        {...register("password")}
      />
      <Box sx={{ height: "16px", marginBottom: "16px" }} textAlign="right">
        <Typography variant="body2">
          <Link to="/reset-password" style={{ textDecoration: "none" }}>Forgot password?</Link>
        </Typography>
      </Box>
      <LoadingButton
        loading={props.isLoading}
        disableElevation
        variant="contained"
        type="submit"
        fullWidth
        sx={{ mt: 2, mb: 2, height: "56px" }}
      >
        <span>Log in</span>
      </LoadingButton>
    </Box >
  );
};

export default LoginForm;
